export type ControlCause = {
  cause: string;
  probability: number;
};

export type ControlFault = {
  id: string;
  category_id: string | null;
  device_ar: string;
  name_ar: string;
  description_ar: string;
  symptoms: string[];
  causes: ControlCause[];
  tests: {
    test: string;
    location: string;
    method: string;
    normal: string;
    faulty: string;
  }[];
  solutions: string[];
  severity: string;
  safety_warnings: string[];
  error_code: string | null;
  keywords: string;
  next_question_key: string | null;
};

type Row = [
  string,
  string,
  string,
  string,
  string,
  ControlCause[],
  string[],
  string,
  string
];

const C = (
  cause: string,
  probability: number,
): ControlCause => ({
  cause,
  probability,
});

const rows: Row[] = [
  [
    "control-001",
    "مصدر السيطرة",
    "ماكو فولت سيطرة نهائياً",
    "أكو خلل بدائرة تغذية السيطرة يخلي التشغيل أو الإشارات مو طبيعية.",
    "ماكو فولت سيطرة نهائياً",
    [C("فيوز أو قاطع السيطرة فاصل", 45), C("أكو قطع أو ربط مرخي بدائرة التغذية", 35), C("محولة السيطرة أو مزود 24VDC متضرر", 20)],
    ["افحص مصدر فولت السيطرة والحمايات.", "خلي فني يفحص المحولة أو مزود 24VDC والربطات."],
    "عالية",
    "ماكو فولت سيطرة نهائياً basic control control circuit",
  ],
  [
    "control-002",
    "مصدر السيطرة",
    "ماكو خرج من محولة السيطرة",
    "أكو خلل بدائرة تغذية السيطرة يخلي التشغيل أو الإشارات مو طبيعية.",
    "ماكو خرج من محولة السيطرة",
    [C("فيوز أو قاطع السيطرة فاصل", 45), C("أكو قطع أو ربط مرخي بدائرة التغذية", 35), C("محولة السيطرة أو مزود 24VDC متضرر", 20)],
    ["افحص مصدر فولت السيطرة والحمايات.", "خلي فني يفحص المحولة أو مزود 24VDC والربطات."],
    "عالية",
    "ماكو خرج من محولة السيطرة basic control control circuit",
  ],
  [
    "control-003",
    "مصدر السيطرة",
    "فولت خرج المحولة واطي",
    "أكو خلل بدائرة تغذية السيطرة يخلي التشغيل أو الإشارات مو طبيعية.",
    "فولت خرج المحولة واطي",
    [C("فيوز أو قاطع السيطرة فاصل", 45), C("أكو قطع أو ربط مرخي بدائرة التغذية", 35), C("محولة السيطرة أو مزود 24VDC متضرر", 20)],
    ["افحص مصدر فولت السيطرة والحمايات.", "خلي فني يفحص المحولة أو مزود 24VDC والربطات."],
    "عالية",
    "فولت خرج المحولة واطي basic control control circuit",
  ],
  [
    "control-004",
    "مصدر السيطرة",
    "حرارة محولة السيطرة ترتفع",
    "أكو خلل بدائرة تغذية السيطرة يخلي التشغيل أو الإشارات مو طبيعية.",
    "حرارة محولة السيطرة ترتفع",
    [C("فيوز أو قاطع السيطرة فاصل", 45), C("أكو قطع أو ربط مرخي بدائرة التغذية", 35), C("محولة السيطرة أو مزود 24VDC متضرر", 20)],
    ["افحص مصدر فولت السيطرة والحمايات.", "خلي فني يفحص المحولة أو مزود 24VDC والربطات."],
    "عالية",
    "حرارة محولة السيطرة ترتفع basic control control circuit",
  ],
  [
    "control-005",
    "مصدر السيطرة",
    "المحولة تطلع طنين قوي",
    "أكو خلل بدائرة تغذية السيطرة يخلي التشغيل أو الإشارات مو طبيعية.",
    "المحولة تطلع طنين قوي",
    [C("فيوز أو قاطع السيطرة فاصل", 45), C("أكو قطع أو ربط مرخي بدائرة التغذية", 35), C("محولة السيطرة أو مزود 24VDC متضرر", 20)],
    ["افحص مصدر فولت السيطرة والحمايات.", "خلي فني يفحص المحولة أو مزود 24VDC والربطات."],
    "عالية",
    "المحولة تطلع طنين قوي basic control control circuit",
  ],
  [
    "control-006",
    "مصدر السيطرة",
    "مزود 24VDC ما يطلع فولت",
    "أكو خلل بدائرة تغذية السيطرة يخلي التشغيل أو الإشارات مو طبيعية.",
    "مزود 24VDC ما يطلع فولت",
    [C("فيوز أو قاطع السيطرة فاصل", 45), C("أكو قطع أو ربط مرخي بدائرة التغذية", 35), C("محولة السيطرة أو مزود 24VDC متضرر", 20)],
    ["افحص مصدر فولت السيطرة والحمايات.", "خلي فني يفحص المحولة أو مزود 24VDC والربطات."],
    "عالية",
    "مزود 24VDC ما يطلع فولت basic control control circuit",
  ],
  [
    "control-007",
    "مصدر السيطرة",
    "فولت 24VDC واطي",
    "أكو خلل بدائرة تغذية السيطرة يخلي التشغيل أو الإشارات مو طبيعية.",
    "فولت 24VDC واطي",
    [C("فيوز أو قاطع السيطرة فاصل", 45), C("أكو قطع أو ربط مرخي بدائرة التغذية", 35), C("محولة السيطرة أو مزود 24VDC متضرر", 20)],
    ["افحص مصدر فولت السيطرة والحمايات.", "خلي فني يفحص المحولة أو مزود 24VDC والربطات."],
    "عالية",
    "فولت 24VDC واطي basic control control circuit",
  ],
  [
    "control-008",
    "مصدر السيطرة",
    "فولت 24VDC يصعد وينزل",
    "أكو خلل بدائرة تغذية السيطرة يخلي التشغيل أو الإشارات مو طبيعية.",
    "فولت 24VDC يصعد وينزل",
    [C("فيوز أو قاطع السيطرة فاصل", 45), C("أكو قطع أو ربط مرخي بدائرة التغذية", 35), C("محولة السيطرة أو مزود 24VDC متضرر", 20)],
    ["افحص مصدر فولت السيطرة والحمايات.", "خلي فني يفحص المحولة أو مزود 24VDC والربطات."],
    "عالية",
    "فولت 24VDC يصعد وينزل basic control control circuit",
  ],
  [
    "control-009",
    "مصدر السيطرة",
    "حرارة مزود 24VDC ترتفع",
    "أكو خلل بدائرة تغذية السيطرة يخلي التشغيل أو الإشارات مو طبيعية.",
    "حرارة مزود 24VDC ترتفع",
    [C("فيوز أو قاطع السيطرة فاصل", 45), C("أكو قطع أو ربط مرخي بدائرة التغذية", 35), C("محولة السيطرة أو مزود 24VDC متضرر", 20)],
    ["افحص مصدر فولت السيطرة والحمايات.", "خلي فني يفحص المحولة أو مزود 24VDC والربطات."],
    "عالية",
    "حرارة مزود 24VDC ترتفع basic control control circuit",
  ],
  [
    "control-010",
    "مصدر السيطرة",
    "فيوز السيطرة يفصل باستمرار",
    "أكو خلل بدائرة تغذية السيطرة يخلي التشغيل أو الإشارات مو طبيعية.",
    "فيوز السيطرة يفصل باستمرار",
    [C("فيوز أو قاطع السيطرة فاصل", 45), C("أكو قطع أو ربط مرخي بدائرة التغذية", 35), C("محولة السيطرة أو مزود 24VDC متضرر", 20)],
    ["افحص مصدر فولت السيطرة والحمايات.", "خلي فني يفحص المحولة أو مزود 24VDC والربطات."],
    "عالية",
    "فيوز السيطرة يفصل باستمرار basic control control circuit",
  ],
  [
    "control-011",
    "الأزرار والسويتجات",
    "زر Start ما يشتغل",
    "أمر التشغيل أو الإيقاف أو اختيار الوضع ما يوصل بصورة صحيحة.",
    "زر Start ما يشتغل",
    [C("نقاط الكونتاكت متضررة أو متآكلة", 45), C("أكو سلك أو ترمنل مفصول أو مرخي", 35), C("الميكانيكية داخل الزر أو السويتج عالقة", 20)],
    ["افحص الزر أو السويتج والتوصيلات بعد العزل.", "بدل القطعة إذا نقاطها أو حركتها مو ثابتة."],
    "متوسطة",
    "زر Start ما يشتغل basic control control circuit",
  ],
  [
    "control-012",
    "الأزرار والسويتجات",
    "زر Start يعلق",
    "أمر التشغيل أو الإيقاف أو اختيار الوضع ما يوصل بصورة صحيحة.",
    "زر Start يعلق",
    [C("نقاط الكونتاكت متضررة أو متآكلة", 45), C("أكو سلك أو ترمنل مفصول أو مرخي", 35), C("الميكانيكية داخل الزر أو السويتج عالقة", 20)],
    ["افحص الزر أو السويتج والتوصيلات بعد العزل.", "بدل القطعة إذا نقاطها أو حركتها مو ثابتة."],
    "متوسطة",
    "زر Start يعلق basic control control circuit",
  ],
  [
    "control-013",
    "الأزرار والسويتجات",
    "زر Stop ما يوقف",
    "أمر التشغيل أو الإيقاف أو اختيار الوضع ما يوصل بصورة صحيحة.",
    "زر Stop ما يوقف",
    [C("نقاط الكونتاكت متضررة أو متآكلة", 45), C("أكو سلك أو ترمنل مفصول أو مرخي", 35), C("الميكانيكية داخل الزر أو السويتج عالقة", 20)],
    ["افحص الزر أو السويتج والتوصيلات بعد العزل.", "بدل القطعة إذا نقاطها أو حركتها مو ثابتة."],
    "حرجة",
    "زر Stop ما يوقف basic control control circuit",
  ],
  [
    "control-014",
    "الأزرار والسويتجات",
    "زر Stop يفصل بدون ضغط",
    "أمر التشغيل أو الإيقاف أو اختيار الوضع ما يوصل بصورة صحيحة.",
    "زر Stop يفصل بدون ضغط",
    [C("نقاط الكونتاكت متضررة أو متآكلة", 45), C("أكو سلك أو ترمنل مفصول أو مرخي", 35), C("الميكانيكية داخل الزر أو السويتج عالقة", 20)],
    ["افحص الزر أو السويتج والتوصيلات بعد العزل.", "بدل القطعة إذا نقاطها أو حركتها مو ثابتة."],
    "متوسطة",
    "زر Stop يفصل بدون ضغط basic control control circuit",
  ],
  [
    "control-015",
    "الأزرار والسويتجات",
    "زر الطوارئ E-Stop ما يوقف المعدة",
    "أمر التشغيل أو الإيقاف أو اختيار الوضع ما يوصل بصورة صحيحة.",
    "زر الطوارئ E-Stop ما يوقف المعدة",
    [C("نقاط الكونتاكت متضررة أو متآكلة", 45), C("أكو سلك أو ترمنل مفصول أو مرخي", 35), C("الميكانيكية داخل الزر أو السويتج عالقة", 20)],
    ["افحص الزر أو السويتج والتوصيلات بعد العزل.", "بدل القطعة إذا نقاطها أو حركتها مو ثابتة."],
    "حرجة",
    "زر الطوارئ E-Stop ما يوقف المعدة basic control control circuit",
  ],
  [
    "control-016",
    "الأزرار والسويتجات",
    "زر الطوارئ E-Stop ما يقبل Reset",
    "أمر التشغيل أو الإيقاف أو اختيار الوضع ما يوصل بصورة صحيحة.",
    "زر الطوارئ E-Stop ما يقبل Reset",
    [C("نقاط الكونتاكت متضررة أو متآكلة", 45), C("أكو سلك أو ترمنل مفصول أو مرخي", 35), C("الميكانيكية داخل الزر أو السويتج عالقة", 20)],
    ["افحص الزر أو السويتج والتوصيلات بعد العزل.", "بدل القطعة إذا نقاطها أو حركتها مو ثابتة."],
    "حرجة",
    "زر الطوارئ E-Stop ما يقبل Reset basic control control circuit",
  ],
  [
    "control-017",
    "الأزرار والسويتجات",
    "Selector Auto/Manual ما يبدل الوضع",
    "أمر التشغيل أو الإيقاف أو اختيار الوضع ما يوصل بصورة صحيحة.",
    "Selector Auto/Manual ما يبدل الوضع",
    [C("نقاط الكونتاكت متضررة أو متآكلة", 45), C("أكو سلك أو ترمنل مفصول أو مرخي", 35), C("الميكانيكية داخل الزر أو السويتج عالقة", 20)],
    ["افحص الزر أو السويتج والتوصيلات بعد العزل.", "بدل القطعة إذا نقاطها أو حركتها مو ثابتة."],
    "متوسطة",
    "Selector Auto/Manual ما يبدل الوضع basic control control circuit",
  ],
  [
    "control-018",
    "الأزرار والسويتجات",
    "Selector يعطي وضعين بنفس الوقت",
    "أمر التشغيل أو الإيقاف أو اختيار الوضع ما يوصل بصورة صحيحة.",
    "Selector يعطي وضعين بنفس الوقت",
    [C("نقاط الكونتاكت متضررة أو متآكلة", 45), C("أكو سلك أو ترمنل مفصول أو مرخي", 35), C("الميكانيكية داخل الزر أو السويتج عالقة", 20)],
    ["افحص الزر أو السويتج والتوصيلات بعد العزل.", "بدل القطعة إذا نقاطها أو حركتها مو ثابتة."],
    "متوسطة",
    "Selector يعطي وضعين بنفس الوقت basic control control circuit",
  ],
  [
    "control-019",
    "الأزرار والسويتجات",
    "Limit Switch ما يشتغل",
    "أمر التشغيل أو الإيقاف أو اختيار الوضع ما يوصل بصورة صحيحة.",
    "Limit Switch ما يشتغل",
    [C("نقاط الكونتاكت متضررة أو متآكلة", 45), C("أكو سلك أو ترمنل مفصول أو مرخي", 35), C("الميكانيكية داخل الزر أو السويتج عالقة", 20)],
    ["افحص الزر أو السويتج والتوصيلات بعد العزل.", "بدل القطعة إذا نقاطها أو حركتها مو ثابتة."],
    "متوسطة",
    "Limit Switch ما يشتغل basic control control circuit",
  ],
  [
    "control-020",
    "الأزرار والسويتجات",
    "Limit Switch يظل مضغوط",
    "أمر التشغيل أو الإيقاف أو اختيار الوضع ما يوصل بصورة صحيحة.",
    "Limit Switch يظل مضغوط",
    [C("نقاط الكونتاكت متضررة أو متآكلة", 45), C("أكو سلك أو ترمنل مفصول أو مرخي", 35), C("الميكانيكية داخل الزر أو السويتج عالقة", 20)],
    ["افحص الزر أو السويتج والتوصيلات بعد العزل.", "بدل القطعة إذا نقاطها أو حركتها مو ثابتة."],
    "متوسطة",
    "Limit Switch يظل مضغوط basic control control circuit",
  ],
  [
    "control-021",
    "الأزرار والسويتجات",
    "Foot Switch ما يعطي أمر",
    "أمر التشغيل أو الإيقاف أو اختيار الوضع ما يوصل بصورة صحيحة.",
    "Foot Switch ما يعطي أمر",
    [C("نقاط الكونتاكت متضررة أو متآكلة", 45), C("أكو سلك أو ترمنل مفصول أو مرخي", 35), C("الميكانيكية داخل الزر أو السويتج عالقة", 20)],
    ["افحص الزر أو السويتج والتوصيلات بعد العزل.", "بدل القطعة إذا نقاطها أو حركتها مو ثابتة."],
    "متوسطة",
    "Foot Switch ما يعطي أمر basic control control circuit",
  ],
  [
    "control-022",
    "الأزرار والسويتجات",
    "Key Switch ما يشتغل",
    "أمر التشغيل أو الإيقاف أو اختيار الوضع ما يوصل بصورة صحيحة.",
    "Key Switch ما يشتغل",
    [C("نقاط الكونتاكت متضررة أو متآكلة", 45), C("أكو سلك أو ترمنل مفصول أو مرخي", 35), C("الميكانيكية داخل الزر أو السويتج عالقة", 20)],
    ["افحص الزر أو السويتج والتوصيلات بعد العزل.", "بدل القطعة إذا نقاطها أو حركتها مو ثابتة."],
    "متوسطة",
    "Key Switch ما يشتغل basic control control circuit",
  ],
  [
    "control-023",
    "الأزرار والسويتجات",
    "زر Reset ما يرجع الدائرة",
    "أمر التشغيل أو الإيقاف أو اختيار الوضع ما يوصل بصورة صحيحة.",
    "زر Reset ما يرجع الدائرة",
    [C("نقاط الكونتاكت متضررة أو متآكلة", 45), C("أكو سلك أو ترمنل مفصول أو مرخي", 35), C("الميكانيكية داخل الزر أو السويتج عالقة", 20)],
    ["افحص الزر أو السويتج والتوصيلات بعد العزل.", "بدل القطعة إذا نقاطها أو حركتها مو ثابتة."],
    "متوسطة",
    "زر Reset ما يرجع الدائرة basic control control circuit",
  ],
  [
    "control-024",
    "الأزرار والسويتجات",
    "زر Reset يسبب تشغيل بدل Reset فقط",
    "أمر التشغيل أو الإيقاف أو اختيار الوضع ما يوصل بصورة صحيحة.",
    "زر Reset يسبب تشغيل بدل Reset فقط",
    [C("نقاط الكونتاكت متضررة أو متآكلة", 45), C("أكو سلك أو ترمنل مفصول أو مرخي", 35), C("الميكانيكية داخل الزر أو السويتج عالقة", 20)],
    ["افحص الزر أو السويتج والتوصيلات بعد العزل.", "بدل القطعة إذا نقاطها أو حركتها مو ثابتة."],
    "متوسطة",
    "زر Reset يسبب تشغيل بدل Reset فقط basic control control circuit",
  ],
  [
    "control-025",
    "الكونتاكتور",
    "الكونتاكتور ما يسحب",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "الكونتاكتور ما يسحب",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "الكونتاكتور ما يسحب basic control control circuit",
  ],
  [
    "control-026",
    "الكونتاكتور",
    "الكونتاكتور يسحب ويفصل بسرعة",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "الكونتاكتور يسحب ويفصل بسرعة",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "الكونتاكتور يسحب ويفصل بسرعة basic control control circuit",
  ],
  [
    "control-027",
    "الكونتاكتور",
    "الكونتاكتور يطن",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "الكونتاكتور يطن",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "الكونتاكتور يطن basic control control circuit",
  ],
  [
    "control-028",
    "الكونتاكتور",
    "حرارة ملف الكونتاكتور ترتفع",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "حرارة ملف الكونتاكتور ترتفع",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "حرارة ملف الكونتاكتور ترتفع basic control control circuit",
  ],
  [
    "control-029",
    "الكونتاكتور",
    "ملف الكونتاكتور محترق",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "ملف الكونتاكتور محترق",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "ملف الكونتاكتور محترق basic control control circuit",
  ],
  [
    "control-030",
    "الكونتاكتور",
    "الكونتاكتور ما يفصل بعد إزالة الأمر",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "الكونتاكتور ما يفصل بعد إزالة الأمر",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "الكونتاكتور ما يفصل بعد إزالة الأمر basic control control circuit",
  ],
  [
    "control-031",
    "الكونتاكتور",
    "نقطة رئيسية محترقة",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "نقطة رئيسية محترقة",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "نقطة رئيسية محترقة basic control control circuit",
  ],
  [
    "control-032",
    "الكونتاكتور",
    "فاز يضيع بعد الكونتاكتور",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "فاز يضيع بعد الكونتاكتور",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "فاز يضيع بعد الكونتاكتور basic control control circuit",
  ],
  [
    "control-033",
    "الكونتاكتور",
    "نقطة مساعدة NO ما توصل",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "نقطة مساعدة NO ما توصل",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "نقطة مساعدة NO ما توصل basic control control circuit",
  ],
  [
    "control-034",
    "الكونتاكتور",
    "نقطة مساعدة NC ما تفتح",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "نقطة مساعدة NC ما تفتح",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "نقطة مساعدة NC ما تفتح basic control control circuit",
  ],
  [
    "control-035",
    "الكونتاكتور",
    "الكونتاكتور أصغر من الحمل",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "الكونتاكتور أصغر من الحمل",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "الكونتاكتور أصغر من الحمل basic control control circuit",
  ],
  [
    "control-036",
    "الكونتاكتور",
    "حرارة ترمنلات الكونتاكتور ترتفع",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "حرارة ترمنلات الكونتاكتور ترتفع",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "حرارة ترمنلات الكونتاكتور ترتفع basic control control circuit",
  ],
  [
    "control-037",
    "الكونتاكتور",
    "الكونتاكتور يسحب بس الحمل ما يشتغل",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "الكونتاكتور يسحب بس الحمل ما يشتغل",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "الكونتاكتور يسحب بس الحمل ما يشتغل basic control control circuit",
  ],
  [
    "control-038",
    "الكونتاكتور",
    "الكونتاكتور يتأثر باهتزاز اللوحة",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "الكونتاكتور يتأثر باهتزاز اللوحة",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "الكونتاكتور يتأثر باهتزاز اللوحة basic control control circuit",
  ],
  [
    "control-039",
    "الكونتاكتور",
    "الكونتاكتور ما يغلق للنهاية",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "الكونتاكتور ما يغلق للنهاية",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "الكونتاكتور ما يغلق للنهاية basic control control circuit",
  ],
  [
    "control-040",
    "الكونتاكتور",
    "الكونتاكتور يفصل من ترتفع حرارة اللوحة",
    "الكونتاكتور ما يبدل حالته أو يشتغل بصورة غير مستقرة.",
    "الكونتاكتور يفصل من ترتفع حرارة اللوحة",
    [C("فولت الملف مو موجود أو مو ضمن التصنيف", 45), C("نقاط أو ملف الكونتاكتور متضررة", 35), C("أكو ربط مرخي أو عطل ميكانيكي", 20)],
    ["افحص فولت الملف ودائرة الحماية.", "بدل أو صلح الكونتاكتور إذا النقاط أو الملف متضرر."],
    "عالية",
    "الكونتاكتور يفصل من ترتفع حرارة اللوحة basic control control circuit",
  ],
  [
    "control-041",
    "الأوفرلود",
    "الأوفرلود يفصل باستمرار",
    "حماية الحمل تفصل أو ما تستجيب مثل المطلوب.",
    "الأوفرلود يفصل باستمرار",
    [C("الحمل يسحب تيار أعلى من الطبيعي", 45), C("ضبط الأوفرلود مو مناسب", 35), C("الأوفرلود أو نقاطه المساعدة متضررة", 20)],
    ["راجع تيار الحمل وضبط الحماية.", "لا ترفع الإعداد عشوائياً، وبدل الأوفرلود إذا متضرر."],
    "عالية",
    "الأوفرلود يفصل باستمرار basic control control circuit",
  ],
  [
    "control-042",
    "الأوفرلود",
    "الأوفرلود ما يفصل رغم تيار عالي",
    "حماية الحمل تفصل أو ما تستجيب مثل المطلوب.",
    "الأوفرلود ما يفصل رغم تيار عالي",
    [C("الحمل يسحب تيار أعلى من الطبيعي", 45), C("ضبط الأوفرلود مو مناسب", 35), C("الأوفرلود أو نقاطه المساعدة متضررة", 20)],
    ["راجع تيار الحمل وضبط الحماية.", "لا ترفع الإعداد عشوائياً، وبدل الأوفرلود إذا متضرر."],
    "حرجة",
    "الأوفرلود ما يفصل رغم تيار عالي basic control control circuit",
  ],
  [
    "control-043",
    "الأوفرلود",
    "الأوفرلود ما يقبل Reset",
    "حماية الحمل تفصل أو ما تستجيب مثل المطلوب.",
    "الأوفرلود ما يقبل Reset",
    [C("الحمل يسحب تيار أعلى من الطبيعي", 45), C("ضبط الأوفرلود مو مناسب", 35), C("الأوفرلود أو نقاطه المساعدة متضررة", 20)],
    ["راجع تيار الحمل وضبط الحماية.", "لا ترفع الإعداد عشوائياً، وبدل الأوفرلود إذا متضرر."],
    "عالية",
    "الأوفرلود ما يقبل Reset basic control control circuit",
  ],
  [
    "control-044",
    "الأوفرلود",
    "نقطة NC مال الأوفرلود ما توصل",
    "حماية الحمل تفصل أو ما تستجيب مثل المطلوب.",
    "نقطة NC مال الأوفرلود ما توصل",
    [C("الحمل يسحب تيار أعلى من الطبيعي", 45), C("ضبط الأوفرلود مو مناسب", 35), C("الأوفرلود أو نقاطه المساعدة متضررة", 20)],
    ["راجع تيار الحمل وضبط الحماية.", "لا ترفع الإعداد عشوائياً، وبدل الأوفرلود إذا متضرر."],
    "عالية",
    "نقطة NC مال الأوفرلود ما توصل basic control control circuit",
  ],
  [
    "control-045",
    "الأوفرلود",
    "نقطة NO مال الأوفرلود ما تعطي إنذار",
    "حماية الحمل تفصل أو ما تستجيب مثل المطلوب.",
    "نقطة NO مال الأوفرلود ما تعطي إنذار",
    [C("الحمل يسحب تيار أعلى من الطبيعي", 45), C("ضبط الأوفرلود مو مناسب", 35), C("الأوفرلود أو نقاطه المساعدة متضررة", 20)],
    ["راجع تيار الحمل وضبط الحماية.", "لا ترفع الإعداد عشوائياً، وبدل الأوفرلود إذا متضرر."],
    "عالية",
    "نقطة NO مال الأوفرلود ما تعطي إنذار basic control control circuit",
  ],
  [
    "control-046",
    "الأوفرلود",
    "ضبط الأوفرلود أقل من المطلوب",
    "حماية الحمل تفصل أو ما تستجيب مثل المطلوب.",
    "ضبط الأوفرلود أقل من المطلوب",
    [C("الحمل يسحب تيار أعلى من الطبيعي", 45), C("ضبط الأوفرلود مو مناسب", 35), C("الأوفرلود أو نقاطه المساعدة متضررة", 20)],
    ["راجع تيار الحمل وضبط الحماية.", "لا ترفع الإعداد عشوائياً، وبدل الأوفرلود إذا متضرر."],
    "عالية",
    "ضبط الأوفرلود أقل من المطلوب basic control control circuit",
  ],
  [
    "control-047",
    "الأوفرلود",
    "ضبط الأوفرلود أعلى من المطلوب",
    "حماية الحمل تفصل أو ما تستجيب مثل المطلوب.",
    "ضبط الأوفرلود أعلى من المطلوب",
    [C("الحمل يسحب تيار أعلى من الطبيعي", 45), C("ضبط الأوفرلود مو مناسب", 35), C("الأوفرلود أو نقاطه المساعدة متضررة", 20)],
    ["راجع تيار الحمل وضبط الحماية.", "لا ترفع الإعداد عشوائياً، وبدل الأوفرلود إذا متضرر."],
    "حرجة",
    "ضبط الأوفرلود أعلى من المطلوب basic control control circuit",
  ],
  [
    "control-048",
    "الأوفرلود",
    "Range الأوفرلود مو مناسب للحمل",
    "حماية الحمل تفصل أو ما تستجيب مثل المطلوب.",
    "Range الأوفرلود مو مناسب للحمل",
    [C("الحمل يسحب تيار أعلى من الطبيعي", 45), C("ضبط الأوفرلود مو مناسب", 35), C("الأوفرلود أو نقاطه المساعدة متضررة", 20)],
    ["راجع تيار الحمل وضبط الحماية.", "لا ترفع الإعداد عشوائياً، وبدل الأوفرلود إذا متضرر."],
    "عالية",
    "Range الأوفرلود مو مناسب للحمل basic control control circuit",
  ],
  [
    "control-049",
    "الريليات والتايمرات",
    "الريليه ما يسحب",
    "الريليه أو التايمر ما يبدل الخرج أو يشتغل بتوقيت مو صحيح.",
    "الريليه ما يسحب",
    [C("فولت التغذية أو إشارة التشغيل مو صحيحة", 45), C("نقطة أو ملف الريليه/التايمر متضرر", 35), C("الإعداد أو الـ Function مو مناسب", 20)],
    ["افحص التغذية والإشارة والإعدادات.", "بدل الريليه أو التايمر إذا المدخلات صحيحة والخرج مو طبيعي."],
    "متوسطة",
    "الريليه ما يسحب basic control control circuit",
  ],
  [
    "control-050",
    "الريليات والتايمرات",
    "الريليه يطن أو يقطع",
    "الريليه أو التايمر ما يبدل الخرج أو يشتغل بتوقيت مو صحيح.",
    "الريليه يطن أو يقطع",
    [C("فولت التغذية أو إشارة التشغيل مو صحيحة", 45), C("نقطة أو ملف الريليه/التايمر متضرر", 35), C("الإعداد أو الـ Function مو مناسب", 20)],
    ["افحص التغذية والإشارة والإعدادات.", "بدل الريليه أو التايمر إذا المدخلات صحيحة والخرج مو طبيعي."],
    "متوسطة",
    "الريليه يطن أو يقطع basic control control circuit",
  ],
  [
    "control-051",
    "الريليات والتايمرات",
    "نقطة NO بالريليه ما توصل",
    "الريليه أو التايمر ما يبدل الخرج أو يشتغل بتوقيت مو صحيح.",
    "نقطة NO بالريليه ما توصل",
    [C("فولت التغذية أو إشارة التشغيل مو صحيحة", 45), C("نقطة أو ملف الريليه/التايمر متضرر", 35), C("الإعداد أو الـ Function مو مناسب", 20)],
    ["افحص التغذية والإشارة والإعدادات.", "بدل الريليه أو التايمر إذا المدخلات صحيحة والخرج مو طبيعي."],
    "متوسطة",
    "نقطة NO بالريليه ما توصل basic control control circuit",
  ],
  [
    "control-052",
    "الريليات والتايمرات",
    "نقطة NC بالريليه ما تفتح",
    "الريليه أو التايمر ما يبدل الخرج أو يشتغل بتوقيت مو صحيح.",
    "نقطة NC بالريليه ما تفتح",
    [C("فولت التغذية أو إشارة التشغيل مو صحيحة", 45), C("نقطة أو ملف الريليه/التايمر متضرر", 35), C("الإعداد أو الـ Function مو مناسب", 20)],
    ["افحص التغذية والإشارة والإعدادات.", "بدل الريليه أو التايمر إذا المدخلات صحيحة والخرج مو طبيعي."],
    "متوسطة",
    "نقطة NC بالريليه ما تفتح basic control control circuit",
  ],
  [
    "control-053",
    "الريليات والتايمرات",
    "سوكت الريليه حرارته ترتفع",
    "الريليه أو التايمر ما يبدل الخرج أو يشتغل بتوقيت مو صحيح.",
    "سوكت الريليه حرارته ترتفع",
    [C("فولت التغذية أو إشارة التشغيل مو صحيحة", 45), C("نقطة أو ملف الريليه/التايمر متضرر", 35), C("الإعداد أو الـ Function مو مناسب", 20)],
    ["افحص التغذية والإشارة والإعدادات.", "بدل الريليه أو التايمر إذا المدخلات صحيحة والخرج مو طبيعي."],
    "متوسطة",
    "سوكت الريليه حرارته ترتفع basic control control circuit",
  ],
  [
    "control-054",
    "الريليات والتايمرات",
    "الريليه يشتغل بالعكس عن المطلوب",
    "الريليه أو التايمر ما يبدل الخرج أو يشتغل بتوقيت مو صحيح.",
    "الريليه يشتغل بالعكس عن المطلوب",
    [C("فولت التغذية أو إشارة التشغيل مو صحيحة", 45), C("نقطة أو ملف الريليه/التايمر متضرر", 35), C("الإعداد أو الـ Function مو مناسب", 20)],
    ["افحص التغذية والإشارة والإعدادات.", "بدل الريليه أو التايمر إذا المدخلات صحيحة والخرج مو طبيعي."],
    "متوسطة",
    "الريليه يشتغل بالعكس عن المطلوب basic control control circuit",
  ],
  [
    "control-055",
    "الريليات والتايمرات",
    "التايمر ما يبدأ عد",
    "الريليه أو التايمر ما يبدل الخرج أو يشتغل بتوقيت مو صحيح.",
    "التايمر ما يبدأ عد",
    [C("فولت التغذية أو إشارة التشغيل مو صحيحة", 45), C("نقطة أو ملف الريليه/التايمر متضرر", 35), C("الإعداد أو الـ Function مو مناسب", 20)],
    ["افحص التغذية والإشارة والإعدادات.", "بدل الريليه أو التايمر إذا المدخلات صحيحة والخرج مو طبيعي."],
    "متوسطة",
    "التايمر ما يبدأ عد basic control control circuit",
  ],
  [
    "control-056",
    "الريليات والتايمرات",
    "التايمر يعد بس ما يبدل الكونتاكت",
    "الريليه أو التايمر ما يبدل الخرج أو يشتغل بتوقيت مو صحيح.",
    "التايمر يعد بس ما يبدل الكونتاكت",
    [C("فولت التغذية أو إشارة التشغيل مو صحيحة", 45), C("نقطة أو ملف الريليه/التايمر متضرر", 35), C("الإعداد أو الـ Function مو مناسب", 20)],
    ["افحص التغذية والإشارة والإعدادات.", "بدل الريليه أو التايمر إذا المدخلات صحيحة والخرج مو طبيعي."],
    "متوسطة",
    "التايمر يعد بس ما يبدل الكونتاكت basic control control circuit",
  ],
  [
    "control-057",
    "الريليات والتايمرات",
    "زمن التايمر مو ثابت",
    "الريليه أو التايمر ما يبدل الخرج أو يشتغل بتوقيت مو صحيح.",
    "زمن التايمر مو ثابت",
    [C("فولت التغذية أو إشارة التشغيل مو صحيحة", 45), C("نقطة أو ملف الريليه/التايمر متضرر", 35), C("الإعداد أو الـ Function مو مناسب", 20)],
    ["افحص التغذية والإشارة والإعدادات.", "بدل الريليه أو التايمر إذا المدخلات صحيحة والخرج مو طبيعي."],
    "متوسطة",
    "زمن التايمر مو ثابت basic control control circuit",
  ],
  [
    "control-058",
    "الريليات والتايمرات",
    "Range التايمر غلط",
    "الريليه أو التايمر ما يبدل الخرج أو يشتغل بتوقيت مو صحيح.",
    "Range التايمر غلط",
    [C("فولت التغذية أو إشارة التشغيل مو صحيحة", 45), C("نقطة أو ملف الريليه/التايمر متضرر", 35), C("الإعداد أو الـ Function مو مناسب", 20)],
    ["افحص التغذية والإشارة والإعدادات.", "بدل الريليه أو التايمر إذا المدخلات صحيحة والخرج مو طبيعي."],
    "متوسطة",
    "Range التايمر غلط basic control control circuit",
  ],
  [
    "control-059",
    "الريليات والتايمرات",
    "On-Delay مستخدم بدل Off-Delay",
    "الريليه أو التايمر ما يبدل الخرج أو يشتغل بتوقيت مو صحيح.",
    "On-Delay مستخدم بدل Off-Delay",
    [C("فولت التغذية أو إشارة التشغيل مو صحيحة", 45), C("نقطة أو ملف الريليه/التايمر متضرر", 35), C("الإعداد أو الـ Function مو مناسب", 20)],
    ["افحص التغذية والإشارة والإعدادات.", "بدل الريليه أو التايمر إذا المدخلات صحيحة والخرج مو طبيعي."],
    "متوسطة",
    "On-Delay مستخدم بدل Off-Delay basic control control circuit",
  ],
  [
    "control-060",
    "الريليات والتايمرات",
    "التايمر Reset كل شوي",
    "الريليه أو التايمر ما يبدل الخرج أو يشتغل بتوقيت مو صحيح.",
    "التايمر Reset كل شوي",
    [C("فولت التغذية أو إشارة التشغيل مو صحيحة", 45), C("نقطة أو ملف الريليه/التايمر متضرر", 35), C("الإعداد أو الـ Function مو مناسب", 20)],
    ["افحص التغذية والإشارة والإعدادات.", "بدل الريليه أو التايمر إذا المدخلات صحيحة والخرج مو طبيعي."],
    "متوسطة",
    "التايمر Reset كل شوي basic control control circuit",
  ],
  [
    "control-061",
    "الريليات والتايمرات",
    "ريليه Latching ما يرجع",
    "الريليه أو التايمر ما يبدل الخرج أو يشتغل بتوقيت مو صحيح.",
    "ريليه Latching ما يرجع",
    [C("فولت التغذية أو إشارة التشغيل مو صحيحة", 45), C("نقطة أو ملف الريليه/التايمر متضرر", 35), C("الإعداد أو الـ Function مو مناسب", 20)],
    ["افحص التغذية والإشارة والإعدادات.", "بدل الريليه أو التايمر إذا المدخلات صحيحة والخرج مو طبيعي."],
    "متوسطة",
    "ريليه Latching ما يرجع basic control control circuit",
  ],
  [
    "control-062",
    "الريليات والتايمرات",
    "ريليه Alarm يبقى فعال بعد Reset",
    "الريليه أو التايمر ما يبدل الخرج أو يشتغل بتوقيت مو صحيح.",
    "ريليه Alarm يبقى فعال بعد Reset",
    [C("فولت التغذية أو إشارة التشغيل مو صحيحة", 45), C("نقطة أو ملف الريليه/التايمر متضرر", 35), C("الإعداد أو الـ Function مو مناسب", 20)],
    ["افحص التغذية والإشارة والإعدادات.", "بدل الريليه أو التايمر إذا المدخلات صحيحة والخرج مو طبيعي."],
    "متوسطة",
    "ريليه Alarm يبقى فعال بعد Reset basic control control circuit",
  ],
  [
    "control-063",
    "دوائر Interlock والاتجاه",
    "Forward يشتغل وReverse ما يشتغل",
    "منطق الاتجاه أو التعشيق ما يمنع الأوامر المتعارضة بصورة صحيحة.",
    "Forward يشتغل وReverse ما يشتغل",
    [C("Electrical Interlock أو Mechanical Interlock متضرر", 45), C("توصيل دائرة السيطرة مو مطابق للمخطط", 35), C("Aux contact أو تايمر متضرر", 20)],
    ["وقف التشغيل إذا الأوامر متعارضة.", "راجع الـ interlock والمخطط والكونتاكتورات بعد العزل."],
    "حرجة",
    "Forward يشتغل وReverse ما يشتغل basic control control circuit",
  ],
  [
    "control-064",
    "دوائر Interlock والاتجاه",
    "Reverse يشتغل وForward ما يشتغل",
    "منطق الاتجاه أو التعشيق ما يمنع الأوامر المتعارضة بصورة صحيحة.",
    "Reverse يشتغل وForward ما يشتغل",
    [C("Electrical Interlock أو Mechanical Interlock متضرر", 45), C("توصيل دائرة السيطرة مو مطابق للمخطط", 35), C("Aux contact أو تايمر متضرر", 20)],
    ["وقف التشغيل إذا الأوامر متعارضة.", "راجع الـ interlock والمخطط والكونتاكتورات بعد العزل."],
    "حرجة",
    "Reverse يشتغل وForward ما يشتغل basic control control circuit",
  ],
  [
    "control-065",
    "دوائر Interlock والاتجاه",
    "Forward وReverse يسحبن سوه",
    "منطق الاتجاه أو التعشيق ما يمنع الأوامر المتعارضة بصورة صحيحة.",
    "Forward وReverse يسحبن سوه",
    [C("Electrical Interlock أو Mechanical Interlock متضرر", 45), C("توصيل دائرة السيطرة مو مطابق للمخطط", 35), C("Aux contact أو تايمر متضرر", 20)],
    ["وقف التشغيل إذا الأوامر متعارضة.", "راجع الـ interlock والمخطط والكونتاكتورات بعد العزل."],
    "حرجة",
    "Forward وReverse يسحبن سوه basic control control circuit",
  ],
  [
    "control-066",
    "دوائر Interlock والاتجاه",
    "المحرك يبدل اتجاه بدون Stop",
    "منطق الاتجاه أو التعشيق ما يمنع الأوامر المتعارضة بصورة صحيحة.",
    "المحرك يبدل اتجاه بدون Stop",
    [C("Electrical Interlock أو Mechanical Interlock متضرر", 45), C("توصيل دائرة السيطرة مو مطابق للمخطط", 35), C("Aux contact أو تايمر متضرر", 20)],
    ["وقف التشغيل إذا الأوامر متعارضة.", "راجع الـ interlock والمخطط والكونتاكتورات بعد العزل."],
    "حرجة",
    "المحرك يبدل اتجاه بدون Stop basic control control circuit",
  ],
  [
    "control-067",
    "دوائر Interlock والاتجاه",
    "Electrical Interlock ما يشتغل",
    "منطق الاتجاه أو التعشيق ما يمنع الأوامر المتعارضة بصورة صحيحة.",
    "Electrical Interlock ما يشتغل",
    [C("Electrical Interlock أو Mechanical Interlock متضرر", 45), C("توصيل دائرة السيطرة مو مطابق للمخطط", 35), C("Aux contact أو تايمر متضرر", 20)],
    ["وقف التشغيل إذا الأوامر متعارضة.", "راجع الـ interlock والمخطط والكونتاكتورات بعد العزل."],
    "حرجة",
    "Electrical Interlock ما يشتغل basic control control circuit",
  ],
  [
    "control-068",
    "دوائر Interlock والاتجاه",
    "Mechanical Interlock عالق",
    "منطق الاتجاه أو التعشيق ما يمنع الأوامر المتعارضة بصورة صحيحة.",
    "Mechanical Interlock عالق",
    [C("Electrical Interlock أو Mechanical Interlock متضرر", 45), C("توصيل دائرة السيطرة مو مطابق للمخطط", 35), C("Aux contact أو تايمر متضرر", 20)],
    ["وقف التشغيل إذا الأوامر متعارضة.", "راجع الـ interlock والمخطط والكونتاكتورات بعد العزل."],
    "حرجة",
    "Mechanical Interlock عالق basic control control circuit",
  ],
  [
    "control-069",
    "دوائر Interlock والاتجاه",
    "كونتاكتور Star ما يسحب",
    "منطق الاتجاه أو التعشيق ما يمنع الأوامر المتعارضة بصورة صحيحة.",
    "كونتاكتور Star ما يسحب",
    [C("Electrical Interlock أو Mechanical Interlock متضرر", 45), C("توصيل دائرة السيطرة مو مطابق للمخطط", 35), C("Aux contact أو تايمر متضرر", 20)],
    ["وقف التشغيل إذا الأوامر متعارضة.", "راجع الـ interlock والمخطط والكونتاكتورات بعد العزل."],
    "حرجة",
    "كونتاكتور Star ما يسحب basic control control circuit",
  ],
  [
    "control-070",
    "دوائر Interlock والاتجاه",
    "كونتاكتور Delta ما يسحب",
    "منطق الاتجاه أو التعشيق ما يمنع الأوامر المتعارضة بصورة صحيحة.",
    "كونتاكتور Delta ما يسحب",
    [C("Electrical Interlock أو Mechanical Interlock متضرر", 45), C("توصيل دائرة السيطرة مو مطابق للمخطط", 35), C("Aux contact أو تايمر متضرر", 20)],
    ["وقف التشغيل إذا الأوامر متعارضة.", "راجع الـ interlock والمخطط والكونتاكتورات بعد العزل."],
    "حرجة",
    "كونتاكتور Delta ما يسحب basic control control circuit",
  ],
  [
    "control-071",
    "دوائر Interlock والاتجاه",
    "Star وDelta يسحبن بنفس الوقت",
    "منطق الاتجاه أو التعشيق ما يمنع الأوامر المتعارضة بصورة صحيحة.",
    "Star وDelta يسحبن بنفس الوقت",
    [C("Electrical Interlock أو Mechanical Interlock متضرر", 45), C("توصيل دائرة السيطرة مو مطابق للمخطط", 35), C("Aux contact أو تايمر متضرر", 20)],
    ["وقف التشغيل إذا الأوامر متعارضة.", "راجع الـ interlock والمخطط والكونتاكتورات بعد العزل."],
    "حرجة",
    "Star وDelta يسحبن بنفس الوقت basic control control circuit",
  ],
  [
    "control-072",
    "دوائر Interlock والاتجاه",
    "التحويل من Star إلى Delta يصير بسرعة زيادة",
    "منطق الاتجاه أو التعشيق ما يمنع الأوامر المتعارضة بصورة صحيحة.",
    "التحويل من Star إلى Delta يصير بسرعة زيادة",
    [C("Electrical Interlock أو Mechanical Interlock متضرر", 45), C("توصيل دائرة السيطرة مو مطابق للمخطط", 35), C("Aux contact أو تايمر متضرر", 20)],
    ["وقف التشغيل إذا الأوامر متعارضة.", "راجع الـ interlock والمخطط والكونتاكتورات بعد العزل."],
    "حرجة",
    "التحويل من Star إلى Delta يصير بسرعة زيادة basic control control circuit",
  ],
  [
    "control-073",
    "دوائر Interlock والاتجاه",
    "التحويل من Star إلى Delta يتأخر هواية",
    "منطق الاتجاه أو التعشيق ما يمنع الأوامر المتعارضة بصورة صحيحة.",
    "التحويل من Star إلى Delta يتأخر هواية",
    [C("Electrical Interlock أو Mechanical Interlock متضرر", 45), C("توصيل دائرة السيطرة مو مطابق للمخطط", 35), C("Aux contact أو تايمر متضرر", 20)],
    ["وقف التشغيل إذا الأوامر متعارضة.", "راجع الـ interlock والمخطط والكونتاكتورات بعد العزل."],
    "حرجة",
    "التحويل من Star إلى Delta يتأخر هواية basic control control circuit",
  ],
  [
    "control-074",
    "دوائر Interlock والاتجاه",
    "دائرة Star/Delta ما تكمل التسلسل",
    "منطق الاتجاه أو التعشيق ما يمنع الأوامر المتعارضة بصورة صحيحة.",
    "دائرة Star/Delta ما تكمل التسلسل",
    [C("Electrical Interlock أو Mechanical Interlock متضرر", 45), C("توصيل دائرة السيطرة مو مطابق للمخطط", 35), C("Aux contact أو تايمر متضرر", 20)],
    ["وقف التشغيل إذا الأوامر متعارضة.", "راجع الـ interlock والمخطط والكونتاكتورات بعد العزل."],
    "حرجة",
    "دائرة Star/Delta ما تكمل التسلسل basic control control circuit",
  ],
  [
    "control-075",
    "الحساسات وسويتجات العملية",
    "Float Switch ما يفصل المضخة",
    "إشارة الحساس أو سويتج العملية ما تتغير مثل المطلوب.",
    "Float Switch ما يفصل المضخة",
    [C("الحساس أو السويتج متضرر", 45), C("التغذية أو السلك مقطوع", 35), C("المحاذاة أو الضبط أو موقع الحساس مو صحيح", 20)],
    ["افحص تغذية الحساس وحالته الميكانيكية أو الضبط.", "بدله أو صحح موقعه إذا الإشارة مو موثوقة."],
    "عالية",
    "Float Switch ما يفصل المضخة basic control control circuit",
  ],
  [
    "control-076",
    "الحساسات وسويتجات العملية",
    "Float Switch ما يشغل المضخة",
    "إشارة الحساس أو سويتج العملية ما تتغير مثل المطلوب.",
    "Float Switch ما يشغل المضخة",
    [C("الحساس أو السويتج متضرر", 45), C("التغذية أو السلك مقطوع", 35), C("المحاذاة أو الضبط أو موقع الحساس مو صحيح", 20)],
    ["افحص تغذية الحساس وحالته الميكانيكية أو الضبط.", "بدله أو صحح موقعه إذا الإشارة مو موثوقة."],
    "عالية",
    "Float Switch ما يشغل المضخة basic control control circuit",
  ],
  [
    "control-077",
    "الحساسات وسويتجات العملية",
    "Pressure Switch ما يفصل",
    "إشارة الحساس أو سويتج العملية ما تتغير مثل المطلوب.",
    "Pressure Switch ما يفصل",
    [C("الحساس أو السويتج متضرر", 45), C("التغذية أو السلك مقطوع", 35), C("المحاذاة أو الضبط أو موقع الحساس مو صحيح", 20)],
    ["افحص تغذية الحساس وحالته الميكانيكية أو الضبط.", "بدله أو صحح موقعه إذا الإشارة مو موثوقة."],
    "عالية",
    "Pressure Switch ما يفصل basic control control circuit",
  ],
  [
    "control-078",
    "الحساسات وسويتجات العملية",
    "Pressure Switch ما يشغل",
    "إشارة الحساس أو سويتج العملية ما تتغير مثل المطلوب.",
    "Pressure Switch ما يشغل",
    [C("الحساس أو السويتج متضرر", 45), C("التغذية أو السلك مقطوع", 35), C("المحاذاة أو الضبط أو موقع الحساس مو صحيح", 20)],
    ["افحص تغذية الحساس وحالته الميكانيكية أو الضبط.", "بدله أو صحح موقعه إذا الإشارة مو موثوقة."],
    "عالية",
    "Pressure Switch ما يشغل basic control control circuit",
  ],
  [
    "control-079",
    "الحساسات وسويتجات العملية",
    "Proximity Sensor ما يعطي إشارة",
    "إشارة الحساس أو سويتج العملية ما تتغير مثل المطلوب.",
    "Proximity Sensor ما يعطي إشارة",
    [C("الحساس أو السويتج متضرر", 45), C("التغذية أو السلك مقطوع", 35), C("المحاذاة أو الضبط أو موقع الحساس مو صحيح", 20)],
    ["افحص تغذية الحساس وحالته الميكانيكية أو الضبط.", "بدله أو صحح موقعه إذا الإشارة مو موثوقة."],
    "عالية",
    "Proximity Sensor ما يعطي إشارة basic control control circuit",
  ],
  [
    "control-080",
    "الحساسات وسويتجات العملية",
    "Proximity Sensor يبقى ON",
    "إشارة الحساس أو سويتج العملية ما تتغير مثل المطلوب.",
    "Proximity Sensor يبقى ON",
    [C("الحساس أو السويتج متضرر", 45), C("التغذية أو السلك مقطوع", 35), C("المحاذاة أو الضبط أو موقع الحساس مو صحيح", 20)],
    ["افحص تغذية الحساس وحالته الميكانيكية أو الضبط.", "بدله أو صحح موقعه إذا الإشارة مو موثوقة."],
    "عالية",
    "Proximity Sensor يبقى ON basic control control circuit",
  ],
  [
    "control-081",
    "الحساسات وسويتجات العملية",
    "Photoelectric Sensor ما يشوف الجسم",
    "إشارة الحساس أو سويتج العملية ما تتغير مثل المطلوب.",
    "Photoelectric Sensor ما يشوف الجسم",
    [C("الحساس أو السويتج متضرر", 45), C("التغذية أو السلك مقطوع", 35), C("المحاذاة أو الضبط أو موقع الحساس مو صحيح", 20)],
    ["افحص تغذية الحساس وحالته الميكانيكية أو الضبط.", "بدله أو صحح موقعه إذا الإشارة مو موثوقة."],
    "عالية",
    "Photoelectric Sensor ما يشوف الجسم basic control control circuit",
  ],
  [
    "control-082",
    "الحساسات وسويتجات العملية",
    "Photoelectric Sensor يعطي إشارات كاذبة",
    "إشارة الحساس أو سويتج العملية ما تتغير مثل المطلوب.",
    "Photoelectric Sensor يعطي إشارات كاذبة",
    [C("الحساس أو السويتج متضرر", 45), C("التغذية أو السلك مقطوع", 35), C("المحاذاة أو الضبط أو موقع الحساس مو صحيح", 20)],
    ["افحص تغذية الحساس وحالته الميكانيكية أو الضبط.", "بدله أو صحح موقعه إذا الإشارة مو موثوقة."],
    "عالية",
    "Photoelectric Sensor يعطي إشارات كاذبة basic control control circuit",
  ],
  [
    "control-083",
    "الحساسات وسويتجات العملية",
    "Level Switch ما يغير حالته",
    "إشارة الحساس أو سويتج العملية ما تتغير مثل المطلوب.",
    "Level Switch ما يغير حالته",
    [C("الحساس أو السويتج متضرر", 45), C("التغذية أو السلك مقطوع", 35), C("المحاذاة أو الضبط أو موقع الحساس مو صحيح", 20)],
    ["افحص تغذية الحساس وحالته الميكانيكية أو الضبط.", "بدله أو صحح موقعه إذا الإشارة مو موثوقة."],
    "عالية",
    "Level Switch ما يغير حالته basic control control circuit",
  ],
  [
    "control-084",
    "الحساسات وسويتجات العملية",
    "Thermostat ما يفصل",
    "إشارة الحساس أو سويتج العملية ما تتغير مثل المطلوب.",
    "Thermostat ما يفصل",
    [C("الحساس أو السويتج متضرر", 45), C("التغذية أو السلك مقطوع", 35), C("المحاذاة أو الضبط أو موقع الحساس مو صحيح", 20)],
    ["افحص تغذية الحساس وحالته الميكانيكية أو الضبط.", "بدله أو صحح موقعه إذا الإشارة مو موثوقة."],
    "عالية",
    "Thermostat ما يفصل basic control control circuit",
  ],
  [
    "control-085",
    "الحساسات وسويتجات العملية",
    "Thermostat ما يشغل",
    "إشارة الحساس أو سويتج العملية ما تتغير مثل المطلوب.",
    "Thermostat ما يشغل",
    [C("الحساس أو السويتج متضرر", 45), C("التغذية أو السلك مقطوع", 35), C("المحاذاة أو الضبط أو موقع الحساس مو صحيح", 20)],
    ["افحص تغذية الحساس وحالته الميكانيكية أو الضبط.", "بدله أو صحح موقعه إذا الإشارة مو موثوقة."],
    "عالية",
    "Thermostat ما يشغل basic control control circuit",
  ],
  [
    "control-086",
    "الحساسات وسويتجات العملية",
    "حساس الباب Safety Switch ما يغير حالته",
    "إشارة الحساس أو سويتج العملية ما تتغير مثل المطلوب.",
    "حساس الباب Safety Switch ما يغير حالته",
    [C("الحساس أو السويتج متضرر", 45), C("التغذية أو السلك مقطوع", 35), C("المحاذاة أو الضبط أو موقع الحساس مو صحيح", 20)],
    ["افحص تغذية الحساس وحالته الميكانيكية أو الضبط.", "بدله أو صحح موقعه إذا الإشارة مو موثوقة."],
    "عالية",
    "حساس الباب Safety Switch ما يغير حالته basic control control circuit",
  ],
  [
    "control-087",
    "أسلاك ودائرة السيطرة",
    "سلك سيطرة مقطوع",
    "أكو مشكلة بالتوصيلات أو الإشارات تخلي دائرة السيطرة تشتغل بشكل متقطع أو غلط.",
    "سلك سيطرة مقطوع",
    [C("أكو ترمنل مرخي أو سلك مقطوع", 45), C("العازل متضرر أو أكو شورت/أرضي", 35), C("تشويش كهربائي أو توصيل مو مطابق للمخطط", 20)],
    ["افصل وعزل التغذية وافحص الأسلاك والترمنلات.", "صحح التوصيل أو العزل وحدث الترقيم إذا لازم."],
    "عالية",
    "سلك سيطرة مقطوع basic control control circuit",
  ],
  [
    "control-088",
    "أسلاك ودائرة السيطرة",
    "سلكين سيطرة عاملين شورت",
    "أكو مشكلة بالتوصيلات أو الإشارات تخلي دائرة السيطرة تشتغل بشكل متقطع أو غلط.",
    "سلكين سيطرة عاملين شورت",
    [C("أكو ترمنل مرخي أو سلك مقطوع", 45), C("العازل متضرر أو أكو شورت/أرضي", 35), C("تشويش كهربائي أو توصيل مو مطابق للمخطط", 20)],
    ["افصل وعزل التغذية وافحص الأسلاك والترمنلات.", "صحح التوصيل أو العزل وحدث الترقيم إذا لازم."],
    "حرجة",
    "سلكين سيطرة عاملين شورت basic control control circuit",
  ],
  [
    "control-089",
    "أسلاك ودائرة السيطرة",
    "سلك سيطرة لامس الأرضي",
    "أكو مشكلة بالتوصيلات أو الإشارات تخلي دائرة السيطرة تشتغل بشكل متقطع أو غلط.",
    "سلك سيطرة لامس الأرضي",
    [C("أكو ترمنل مرخي أو سلك مقطوع", 45), C("العازل متضرر أو أكو شورت/أرضي", 35), C("تشويش كهربائي أو توصيل مو مطابق للمخطط", 20)],
    ["افصل وعزل التغذية وافحص الأسلاك والترمنلات.", "صحح التوصيل أو العزل وحدث الترقيم إذا لازم."],
    "حرجة",
    "سلك سيطرة لامس الأرضي basic control control circuit",
  ],
  [
    "control-090",
    "أسلاك ودائرة السيطرة",
    "ترمنل مرخي",
    "أكو مشكلة بالتوصيلات أو الإشارات تخلي دائرة السيطرة تشتغل بشكل متقطع أو غلط.",
    "ترمنل مرخي",
    [C("أكو ترمنل مرخي أو سلك مقطوع", 45), C("العازل متضرر أو أكو شورت/أرضي", 35), C("تشويش كهربائي أو توصيل مو مطابق للمخطط", 20)],
    ["افصل وعزل التغذية وافحص الأسلاك والترمنلات.", "صحح التوصيل أو العزل وحدث الترقيم إذا لازم."],
    "عالية",
    "ترمنل مرخي basic control control circuit",
  ],
  [
    "control-091",
    "أسلاك ودائرة السيطرة",
    "حرارة ترمنل السيطرة ترتفع",
    "أكو مشكلة بالتوصيلات أو الإشارات تخلي دائرة السيطرة تشتغل بشكل متقطع أو غلط.",
    "حرارة ترمنل السيطرة ترتفع",
    [C("أكو ترمنل مرخي أو سلك مقطوع", 45), C("العازل متضرر أو أكو شورت/أرضي", 35), C("تشويش كهربائي أو توصيل مو مطابق للمخطط", 20)],
    ["افصل وعزل التغذية وافحص الأسلاك والترمنلات.", "صحح التوصيل أو العزل وحدث الترقيم إذا لازم."],
    "عالية",
    "حرارة ترمنل السيطرة ترتفع basic control control circuit",
  ],
  [
    "control-092",
    "أسلاك ودائرة السيطرة",
    "كيبل السيطرة قريب من كيبل القدرة ويسبب Noise",
    "أكو مشكلة بالتوصيلات أو الإشارات تخلي دائرة السيطرة تشتغل بشكل متقطع أو غلط.",
    "كيبل السيطرة قريب من كيبل القدرة ويسبب Noise",
    [C("أكو ترمنل مرخي أو سلك مقطوع", 45), C("العازل متضرر أو أكو شورت/أرضي", 35), C("تشويش كهربائي أو توصيل مو مطابق للمخطط", 20)],
    ["افصل وعزل التغذية وافحص الأسلاك والترمنلات.", "صحح التوصيل أو العزل وحدث الترقيم إذا لازم."],
    "عالية",
    "كيبل السيطرة قريب من كيبل القدرة ويسبب Noise basic control control circuit",
  ],
  [
    "control-093",
    "أسلاك ودائرة السيطرة",
    "ملف الكونتاكتور يسوي تشويش عند الفصل",
    "أكو مشكلة بالتوصيلات أو الإشارات تخلي دائرة السيطرة تشتغل بشكل متقطع أو غلط.",
    "ملف الكونتاكتور يسوي تشويش عند الفصل",
    [C("أكو ترمنل مرخي أو سلك مقطوع", 45), C("العازل متضرر أو أكو شورت/أرضي", 35), C("تشويش كهربائي أو توصيل مو مطابق للمخطط", 20)],
    ["افصل وعزل التغذية وافحص الأسلاك والترمنلات.", "صحح التوصيل أو العزل وحدث الترقيم إذا لازم."],
    "عالية",
    "ملف الكونتاكتور يسوي تشويش عند الفصل basic control control circuit",
  ],
  [
    "control-094",
    "أسلاك ودائرة السيطرة",
    "لمبة Power ما تشتغل",
    "أكو مشكلة بالتوصيلات أو الإشارات تخلي دائرة السيطرة تشتغل بشكل متقطع أو غلط.",
    "لمبة Power ما تشتغل",
    [C("أكو ترمنل مرخي أو سلك مقطوع", 45), C("العازل متضرر أو أكو شورت/أرضي", 35), C("تشويش كهربائي أو توصيل مو مطابق للمخطط", 20)],
    ["افصل وعزل التغذية وافحص الأسلاك والترمنلات.", "صحح التوصيل أو العزل وحدث الترقيم إذا لازم."],
    "عالية",
    "لمبة Power ما تشتغل basic control control circuit",
  ],
  [
    "control-095",
    "أسلاك ودائرة السيطرة",
    "لمبة Run ما تشتغل",
    "أكو مشكلة بالتوصيلات أو الإشارات تخلي دائرة السيطرة تشتغل بشكل متقطع أو غلط.",
    "لمبة Run ما تشتغل",
    [C("أكو ترمنل مرخي أو سلك مقطوع", 45), C("العازل متضرر أو أكو شورت/أرضي", 35), C("تشويش كهربائي أو توصيل مو مطابق للمخطط", 20)],
    ["افصل وعزل التغذية وافحص الأسلاك والترمنلات.", "صحح التوصيل أو العزل وحدث الترقيم إذا لازم."],
    "عالية",
    "لمبة Run ما تشتغل basic control control circuit",
  ],
  [
    "control-096",
    "أسلاك ودائرة السيطرة",
    "لمبة Fault تبقى شغالة بعد Reset",
    "أكو مشكلة بالتوصيلات أو الإشارات تخلي دائرة السيطرة تشتغل بشكل متقطع أو غلط.",
    "لمبة Fault تبقى شغالة بعد Reset",
    [C("أكو ترمنل مرخي أو سلك مقطوع", 45), C("العازل متضرر أو أكو شورت/أرضي", 35), C("تشويش كهربائي أو توصيل مو مطابق للمخطط", 20)],
    ["افصل وعزل التغذية وافحص الأسلاك والترمنلات.", "صحح التوصيل أو العزل وحدث الترقيم إذا لازم."],
    "عالية",
    "لمبة Fault تبقى شغالة بعد Reset basic control control circuit",
  ],
  [
    "control-097",
    "أسلاك ودائرة السيطرة",
    "الجرس Buzzer ما يشتغل وقت العطل",
    "أكو مشكلة بالتوصيلات أو الإشارات تخلي دائرة السيطرة تشتغل بشكل متقطع أو غلط.",
    "الجرس Buzzer ما يشتغل وقت العطل",
    [C("أكو ترمنل مرخي أو سلك مقطوع", 45), C("العازل متضرر أو أكو شورت/أرضي", 35), C("تشويش كهربائي أو توصيل مو مطابق للمخطط", 20)],
    ["افصل وعزل التغذية وافحص الأسلاك والترمنلات.", "صحح التوصيل أو العزل وحدث الترقيم إذا لازم."],
    "عالية",
    "الجرس Buzzer ما يشتغل وقت العطل basic control control circuit",
  ],
  [
    "control-098",
    "أسلاك ودائرة السيطرة",
    "الجرس Buzzer ما يوقف بعد Reset",
    "أكو مشكلة بالتوصيلات أو الإشارات تخلي دائرة السيطرة تشتغل بشكل متقطع أو غلط.",
    "الجرس Buzzer ما يوقف بعد Reset",
    [C("أكو ترمنل مرخي أو سلك مقطوع", 45), C("العازل متضرر أو أكو شورت/أرضي", 35), C("تشويش كهربائي أو توصيل مو مطابق للمخطط", 20)],
    ["افصل وعزل التغذية وافحص الأسلاك والترمنلات.", "صحح التوصيل أو العزل وحدث الترقيم إذا لازم."],
    "حرجة",
    "الجرس Buzzer ما يوقف بعد Reset basic control control circuit",
  ],
  [
    "control-099",
    "أسلاك ودائرة السيطرة",
    "دائرة المسك Hold ما تمسك",
    "أكو مشكلة بالتوصيلات أو الإشارات تخلي دائرة السيطرة تشتغل بشكل متقطع أو غلط.",
    "دائرة المسك Hold ما تمسك",
    [C("أكو ترمنل مرخي أو سلك مقطوع", 45), C("العازل متضرر أو أكو شورت/أرضي", 35), C("تشويش كهربائي أو توصيل مو مطابق للمخطط", 20)],
    ["افصل وعزل التغذية وافحص الأسلاك والترمنلات.", "صحح التوصيل أو العزل وحدث الترقيم إذا لازم."],
    "عالية",
    "دائرة المسك Hold ما تمسك basic control control circuit",
  ],
  [
    "control-100",
    "أسلاك ودائرة السيطرة",
    "دائرة المسك Hold ما تفصل بأمر Stop",
    "أكو مشكلة بالتوصيلات أو الإشارات تخلي دائرة السيطرة تشتغل بشكل متقطع أو غلط.",
    "دائرة المسك Hold ما تفصل بأمر Stop",
    [C("أكو ترمنل مرخي أو سلك مقطوع", 45), C("العازل متضرر أو أكو شورت/أرضي", 35), C("تشويش كهربائي أو توصيل مو مطابق للمخطط", 20)],
    ["افصل وعزل التغذية وافحص الأسلاك والترمنلات.", "صحح التوصيل أو العزل وحدث الترقيم إذا لازم."],
    "عالية",
    "دائرة المسك Hold ما تفصل بأمر Stop basic control control circuit",
  ],
];

export const controlFaults: ControlFault[] = rows.map(
  ([
    id,
    device_ar,
    name_ar,
    description_ar,
    symptom,
    causes,
    solutions,
    severity,
    keywords,
  ]) => {
    const critical = severity === "حرجة";

    return {
      id,
      category_id: null,
      device_ar,
      name_ar,
      description_ar,
      symptoms: [symptom],
      causes,
      tests: [
        {
          test: "الفحص الأولي",
          location: device_ar,
          method:
            "افصل وعزل مصادر الطاقة قبل فتح اللوحة أو فك الأسلاك. لا تعتمد على زر Stop وحده لأن المعدة ممكن ترجع تشتغل بشكل مفاجئ. القياسات على أجزاء حية خليها لفني كهربائي مؤهل وبأجهزة فحص مناسبة.",
          normal:
            "فولت السيطرة ضمن التصنيف، الربطات ثابتة، ماكو حرارة عالية أو حرك، والأزرار والريليات والكونتاكتورات تبدل حالتها بصورة مستقرة.",
          faulty:
            "فولت واطي أو متذبذب، ربط مرخي، نقاط ملتحمة، فصل متكرر أو أمر تشغيل غير متوقع يدل على عطل يحتاج إصلاح.",
        },
      ],
      solutions,
      severity,
      safety_warnings: critical
        ? [
            "تنبيه: أكو خطر صعقة أو تشغيل مفاجئ للمعدة. اعزل الطاقة وسوِّ Lockout/Tagout حسب إجراءات الموقع قبل الصيانة.",
            "العمل على دائرة حية أو تجاوز E-Stop أو interlock أو أي حماية خليه لفني مؤهل وممنوع يكون حل دائم.",
          ]
        : [
            "افصل وعزل التغذية قبل الفك أو إعادة الربط.",
            "إذا شفت شرر أو ذوبان أو ريحة حرك أو تشغيل غير متوقع، وقف المعدة وخلي فني يفحصها.",
          ],
      error_code: null,
      keywords,
      next_question_key: null,
    };
  },
);
